import { useState, useEffect } from 'react';

interface WindowSize {
  width: number;
  height: number;
}

export const useWindowSize = () => {
  // 1. Clean SSR and Initial Render Fix: Initialize state using a safe lazy function standard
  const [windowSize, setWindowSize] = useState<WindowSize>(() => ({
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0,
  }));

  useEffect(() => {
    if (typeof window === 'undefined') return;

    // 2. Exhaustive Dependencies Fix: Define the handler inside the effect so it isn't an external dependency
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);

    // 3. Cascading Render Fix: Removed synchronous handleResize() call here.
    // The initial state function already captures the dimensions perfectly on mount.

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // Clean empty dependency array with no linter bypasses needed

  return windowSize;
};

export default useWindowSize;
